<template>
  <div>
    <div v-if="error" class="favourites-not-found">
      <h6>{{ error }}</h6>
    </div>
    <div v-else class="filterGrid -articlesGrid">
      <div class="filterGrid__itemsWrapper">
        <article
          v-for="(article, index) in articles"
          :key="article.url || index"
          class="filterGrid__item"
        >
          <button class="unlikeBtn" @click="removeArticle(article.url)">
            <img :src="deleteIcon" :alt="deleteAlt" />
          </button>
          <ArticleCard :item="article" />
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ArticleCard from '@Feature/Filter/code/Scripts/components/ArticleCard.vue';

export default {
  name: 'WishlistArticle',
  components: { ArticleCard },
  props: {
    deleteIcon: {
      type: String,
      default: null,
    },
    deleteAlt: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: 'Failed to load Articles',
    },
    notFound: {
      type: String,
      default: 'No Wishlisted Articles Found',
    },
  },
  data() {
    return {
      articles: [],
      loading: true,
      error: null,
    };
  },
  mounted() {
    this.loadFavourites();
    window.addEventListener('storage', this.onStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === 'likedArticles') {
        this.loadFavourites();
      }
    },
    loadFavourites() {
      try {
        const storedArticlesString = localStorage.getItem('likedArticles');
        const storedArticles = storedArticlesString ? JSON.parse(storedArticlesString) : [];
        this.articles = storedArticles;
        this.error = storedArticles.length === 0 ? this.notFound : null;
      } catch (err) {
        this.error = this.errorMessage;
        this.articles = [];
      } finally {
        this.loading = false;
      }
    },
    removeArticle(articleUrl) {
      const removedArticle = this.articles.find((a) => a.url === articleUrl);
      this.articles = this.articles.filter((article) => article.url !== articleUrl);
      localStorage.setItem('likedArticles', JSON.stringify(this.articles));
      this.error = this.articles.length === 0 ? this.notFound : null;
      eventBus.emit('wishlist-updated');
      if (removedArticle) {
        this.triggerGtm(removedArticle);
      }
    },
    triggerGtm(article) {
      const articleLikeDislikeObj = {
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Wishlist',
        eventAction: 'Article Wishlist',
        eventLabel: article?.itemResult?.title || '',
        article_info: article?.itemResult?.title || '',
        event_name: 'remove_from_wishlist',
      };
      window.dataLayer?.push(articleLikeDislikeObj);
    },
  },
};
</script>

<style lang="scss" scoped>
.unlikeBtn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 5;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;

  img {
    width: 30px;
    height: 30px;
  }
}

.favourites-not-found {
  text-align: center;
}
</style>
